//  key for 'true' or 'false' value for whether Copilot was previously open when the page loaded (i.e. open after a page reload)
export const COPILOT_INITIALIZE_OPEN = 'copilot-initialize-open';